module.exports = __webpack_public_path__ + "static/media/about3.f4d24b5d.jpg";